import React from 'react';
import { customerLocationState } from '../../StoreLocator/customerLocationState';
import { openStoreLocatorSidebar } from '../../StoreLocator/storeLocatorSidebarState';
import styles from './style.module.scss';
import StoreLocatorAction from './StoreLocatorAction';
import { StoreLocatorSidebarPdpData } from '../../StoreLocator/storeLocatorTypes';

const SddOmniTabMessagingView = ({
  isSizeSelected,
  shouldShowDeliveryMessage,
  shouldShowErrorMessage,
  errorMessage,
  sidebarPdpData,
  isAvailableForDelivery,
  deliveryTypeLowerCased,
}: {
  isSizeSelected: boolean;
  shouldShowDeliveryMessage: boolean;
  shouldShowErrorMessage: boolean;
  errorMessage: string;
  sidebarPdpData: StoreLocatorSidebarPdpData | null;
  isAvailableForDelivery: boolean;
  deliveryTypeLowerCased?: string;
}) => {
  const prefix = `${deliveryTypeLowerCased === 'nextday_delivery' ? 'Next Day' : 'Same Day'} Delivery`;
  const availabilityMessage = isAvailableForDelivery ? 'Available to' : 'Not available to';
  const noSizeSelectMessage = 'Select a size to check availability';

  const handleLocationClick = () => {
    openStoreLocatorSidebar({ feature: 'sdd', pdpProps: sidebarPdpData || undefined, page: 'pdp' });
  };

  const message = (
    <>
      {isSizeSelected ? (
        shouldShowDeliveryMessage ? (
          <>
            {availabilityMessage}{' '}
            <span
              role="button"
              className={`body-small semibold underline ${styles.link}`}
              onClick={() => handleLocationClick()}
            >
              {customerLocationState.sddZip}
            </span>
          </>
        ) : (
          <StoreLocatorAction storeLocatorType="sdd" />
        )
      ) : (
        noSizeSelectMessage
      )}
    </>
  );

  return (
    <>
      <div className={styles.sddMessagingWrapper}>
        <div>
          <span className={styles.aloHistoryIcon}></span>
        </div>
        <div>
          <span className="body-small">
            <span className="body-small semibold">{prefix}</span>: {message}
          </span>
        </div>
      </div>
      {shouldShowErrorMessage && <p className={styles.ssdMessagingNoResults}>{errorMessage}</p>}
    </>
  );
};

export default SddOmniTabMessagingView;
